import { defineComponent as _defineComponent } from 'vue'
import { type PropType, computed, toRefs, useStore } from "@nuxtjs/composition-api";

import { getExperimentsStore } from "@/store/experiments";
import { type DefaultValue } from "@/types";
import defaultValueFactory from "@/utils/experiments/default-value";


export default /*#__PURE__*/_defineComponent({
  __name: 'SplitTest',
  props: {
  name: {
    type: String,
    required: true,
  },
  type: {
    type: String,
    required: true,
  },
  defaultValue: {
    type: String as PropType<DefaultValue>,
    default: undefined,
  },
},
  setup(__props) {

const props = __props;



const { name, type, defaultValue } = toRefs(props);
const store = useStore();

const _defaultValue = computed(() => {
  return defaultValueFactory(defaultValue.value);
});

const variant = computed(() => {
  const experimentsStore = getExperimentsStore(store);
  const variant = type.value === "variant" ? experimentsStore.variant(name) : experimentsStore.flag(name);

  return variant ?? _defaultValue;
});

const experimentsStore = getExperimentsStore(store);
if (type.value === "variant") {
  experimentsStore.fetchVariant({ variantName: name, defaultValue: _defaultValue });
} else {
  experimentsStore.fetchFeatureFlag({ flagName: name, defaultValue: _defaultValue });
}

return { __sfc: true,props, name, type, defaultValue, store, _defaultValue, variant, experimentsStore }
}

})